import { Injectable } from '@angular/core';
import { Observable, of, Subject } from "rxjs";
import {KeyValuePair} from "./KeyValuePair";
import { filter, map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class BroadcastService<T> {
  protected events: KeyValuePair<Subject<T>>[];

  constructor()
    {
        this.events = [];
    }
    
    public BroadcastEvent(key: string, value: any)
    {
        var keyValuePair = this.events.find((event) => {
            return event.key == key;
        });

        if(!keyValuePair)
        {
            this.events.push(
                new KeyValuePair<Subject<T>>(
                    key, 
                    new Subject<T>()
                )
            );
        }
        else
        {
            keyValuePair.value.next(value);
        }
    }

    public GetEvent(key: string): Observable<T>
    {
        var keyValuePair = this.events.find((sub) => {
            return sub.key == key;
        });

        if(keyValuePair)
        {
            return keyValuePair.value.asObservable();        
        }
        else
        {
            var subject = new Subject<T>();
            this.events.push(
                new KeyValuePair<Subject<T>>(
                    key, 
                    subject
                )
            );
            return subject.asObservable();
        }
    }

  
}
